import { Route, Routes } from 'react-router-dom';
import './App.css';
import AdminHome from './pages/admin/AdminHome';

import StudentProfile from './components/admin/StudentProfile';
import AllStudents from './pages/admin/AllStudents';
import AddAssesment from './pages/admin/AddAssesment';
import UpdateAssesment from './pages/admin/UpdateAssesment';
import NewAnnounement from './pages/admin/NewAnnouncement';
import AnnounementsList from './pages/admin/AnnounementsList';
import ViewAnnounement from './pages/admin/ViewAnnounement';
import Login from './pages/Login';
import PrivateRoute from './components/ProtectedRoute';
import StdHome from './pages/student/StdHome';
import Signup from './pages/Singup';
import Home from './components/Home';
import ViewStudentProfile from './pages/admin/ViewStudentProfile';
import NotFOund from './pages/404';

function App() {

  return (
    <>

      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/login' element={<Login />} />
        <Route path='/signup' element={<Signup />} />

        
        <Route path='/dashboard/admin' >
          <Route index element={<PrivateRoute><AdminHome /></PrivateRoute>} />
          <Route path='all-students' element={<PrivateRoute><AllStudents /></PrivateRoute>} />
          <Route path='update-student' element={<PrivateRoute><ViewStudentProfile /></PrivateRoute>} />
          <Route path='student-profile' element={<PrivateRoute><StudentProfile /></PrivateRoute>} />
          <Route path='add-assesment' element={<PrivateRoute><AddAssesment /></PrivateRoute>} />
          <Route path='update-assesment' element={<PrivateRoute><UpdateAssesment /></PrivateRoute>} />
          <Route path='announcements' element={<PrivateRoute><AnnounementsList /></PrivateRoute>} />
          <Route path='announcement' element={<PrivateRoute><ViewAnnounement /></PrivateRoute>} />
          <Route path='new-announcement' element={<PrivateRoute><NewAnnounement /></PrivateRoute>} />
        </Route>
        <Route path='/dashboard/student' >
          <Route index element={<PrivateRoute><StdHome /></PrivateRoute>} />
          <Route path='announcements' element={<PrivateRoute><AnnounementsList /></PrivateRoute>} />
          <Route path='announcement' element={<PrivateRoute><ViewAnnounement /></PrivateRoute>} />
        </Route>
        <Route path='*' element={<NotFOund />} />

      </Routes>
    </>
  )
}

export default App;
